<template>
  <div :style=" { height: getSize }" />
</template>

<script>
export default {
  props: {
    size: { type: Number, default: 4 }
  },
  computed: {
    getSize() {
      return `${this.size}rem`
    }
  }
}
</script>

<style lang="scss" scoped>
  .space {
    height: 4rem;
  }
</style>
